<template>
    <div>
        <el-page-header @back="goBack" content="网元实例" v-if="parent"></el-page-header>
        <h3 style="margin-top: 0px;" v-else>网元实例</h3>
        <div class="divCon" v-if="parent">设备：175.102.132.82</div>

        <div class="divCon">
            <el-input placeholder="搜索" v-model="search">
                <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
        </div>

        <network-unit-instance-list :list="list" />
    </div>
</template>
<script>
import NetworkUnitInstanceList from './common/NetworkUnitInstanceList.vue'
export default {
    name: 'NetworkUnitInstance',
    components: { NetworkUnitInstanceList },
    data: vm => ({
        search: '',
        parent: '',
        list: []
    }),
    computed: {
        totalElement(){
            return this.list.length
        }
    },
    created(){
        this.parent = this.$route.query.p
        this.getList()
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        getList(){
            this.list = [
                {
                    name: 'Qos_20191204_1',
                    moduleNum: 1
                }
            ]
        }
    }
}
</script>
<style scoped>
.divCon{
    width: 40%;
    margin: 20px 0px;
}
</style>